import { render } from "./spouse.html?vue&type=template&id=de569722&external"
import script from "./spouse.js?vue&type=script&lang=js&external"
export * from "./spouse.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__